import { render, staticRenderFns } from "./ComparisonSvg.vue?vue&type=template&id=59d92127&scoped=true&"
import script from "./ComparisonSvg.vue?vue&type=script&lang=js&"
export * from "./ComparisonSvg.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonSvg.vue?vue&type=style&index=0&id=59d92127&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d92127",
  null
  
)

export default component.exports